import React from "react";

import { ArticleLinksView } from "../ArticleLinksView";
import { STEP } from "../consts";
import { useLoggedOutContactUsContextStore } from "../hooks/LoggedOutContactUsContextStore";

import { LoggedOutConfirmationView } from "./LoggedOutConfirmationView";
import { LoggedOutContactUsView } from "./LoggedOutContactUsView";
import { LoggedOutSelectTopicView } from "./LoggedOutSelectTopicView";

export const LoggedOutContactUsStepView: React.FC = () => {
  const [{ currentStep }] = useLoggedOutContactUsContextStore(["currentStep"]);
  switch (currentStep) {
    case STEP.HELP_CENTER_ARTICLE:
      return <ArticleLinksView />;
    case STEP.CONFIRMATION:
      return <LoggedOutConfirmationView />;
    case STEP.LOGGED_OUT_SELECT_TOPIC:
      return <LoggedOutSelectTopicView />;
    case STEP.LOGGED_OUT_CONTACT_US:
      return <LoggedOutContactUsView />;
    default:
      return <LoggedOutSelectTopicView />;
  }
};
